import { action, computed } from "@ember/object"
import { inject } from "@ember/service"
import Component from "@glimmer/component"
import { tracked } from "@glimmer/tracking"
import * as Sentry from "@sentry/browser"
import type { User } from "@shared/models/user"
import fade from "ember-animated/transitions/fade"
import { isNil, truncate } from "lodash-es"
import styles from "./name-and-school.module.css"

interface Sig {
  Args: {
    updateField: (field: string, value: unknown) => void
    user: User
    next: () => void
  }
}

export default class NameAndSchoolComponent extends Component<Sig> {
  readonly styles = styles

  @tracked searchTerm
  @tracked matches
  @tracked selected
  @inject algolia

  fadeTransition = fade

  @computed("args.user.attributes.workplace")
  get canShowSearchBox() {
    return (
      this.args.user.attributes.workplace == "SCHOOL" ||
      this.args.user.attributes.workplace == "DISTRICT_NETWORK_OFFICE"
    )
  }

  @computed("args.user.attributes.workplace", "args.user.attributes.canonicalGroupId")
  get canShowNextButton() {
    return (
      this.args.user.attributes.workplace === "OTHER" ||
      !isNil(this.args.user.attributes.canonicalGroupId)
    )
  }

  @action
  selectWorkplace(selected: User["attributes"]["workplace"]) {
    this.args.updateField("canonicalGroupId", null)
    this.args.updateField("workplace", selected)
    if (selected === "OTHER") {
      this.args.updateField("educationRole", "other")
      this.args.updateField("educationRoleSpecific", "OTHER_OTHER")
    }
  }

  @action selectSchool(selected) {
    this.args.updateField("canonicalGroupId", selected[0].id)
  }

  @action selectNoSchool() {
    this.args.updateField("canonicalGroupId", "NOT_LISTED")
    // this.selectedSchool = {
    //   name: "You can add or create your School or District/Network Office later!",
    // }
  }

  @action removeSelectedSchool() {
    this.args.updateField("canonicalGroupId", null)
  }

  @action searchAlgolia(searchQuery) {
    let term = truncate(searchQuery, { length: 511 })
    let category = this.args.user.attributes.workplace === "SCHOOL" ? "school" : "network"
    this.searchTerm = term
    return this.algolia.canonicalGroups
      .search(term, {
        facetFilters: [`category:${category}`],
      })
      .then((data) => {
        if (this.isDestroyed || this.isDestroying) return
        this.matches = data.hits
        return data.hits
      })
      .catch(function (err) {
        console.error(err)
        Sentry.withScope((scope) => {
          scope.setLevel(Sentry.Severity.Error)
          scope.setExtra("error", err)
          Sentry.captureMessage("Algolia search error")
        })
      })
  }
}
